import { render } from "./ModalImage.vue?vue&type=template&id=d1a9eca0&scoped=true"
import script from "./ModalImage.vue?vue&type=script&lang=js"
export * from "./ModalImage.vue?vue&type=script&lang=js"

import "./ModalImage.vue?vue&type=style&index=0&id=d1a9eca0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1a9eca0"]])

export default __exports__